/**
 * Section "Vus recemment"
 * Recupere les produits consultes (stockes en localStorage par la fiche produit)
 * puis charge les cartes correspondantes via l'API de recherche Shopify
 * (rendu de section : /search?q=id:... OR id:...&section_id=...).
 */
(function () {
  const KEY = 'recently_viewed_products';

  function getIds() {
    try {
      return JSON.parse(window.localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      let ids = getIds();

      // On exclut le produit actuellement consulte.
      if (window.__currentProductId) {
        ids = ids.filter((id) => id !== window.__currentProductId);
      }

      const limit = parseInt(this.dataset.limit, 10) || 4;
      ids = ids.slice(0, limit);

      if (!ids.length) {
        this.remove();
        return;
      }

      const query = ids.map((id) => 'id:' + id).join(' OR ');
      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url =
        root +
        'search?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' +
        limit +
        '&section_id=' +
        this.dataset.sectionId;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const source = doc.querySelector(
            '#RecentlyViewed-' + this.dataset.sectionId + ' .recently-viewed__inner'
          );

          if (!source) {
            this.remove();
            return;
          }

          // On reordonne les cartes selon l'ordre de consultation (l'API de
          // recherche renvoie les resultats par pertinence, pas par recence).
          const list = source.querySelector('.recently-viewed__results');
          if (list) {
            const items = Array.from(list.children);
            items.sort(
              (a, b) =>
                ids.indexOf(parseInt(a.dataset.productId, 10)) -
                ids.indexOf(parseInt(b.dataset.productId, 10))
            );
            items.forEach((li) => list.appendChild(li));
          }

          this.innerHTML = source.outerHTML;

          // Reinitialise les carrousels d'images des cartes et le slider,
          // puis (re)lie le survol variantes couleurs / tailles.
          if (typeof window.initSwipers === 'function') window.initSwipers();
          if (typeof window.showProductSizes === 'function') window.showProductSizes();
          window.dispatchEvent(new Event('resize'));
        })
        .catch(() => this.remove());
    }
  }

  if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', RecentlyViewed);
  }
})();
